"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkLoyalticsCustomerAPI = checkLoyalticsCustomerAPI;
exports.getNewLoyaltics = getNewLoyaltics;
exports.getSecureQuestioner = getSecureQuestioner;
exports.getUserEligibility = getUserEligibility;
exports.linkLoyalticsAccountApi = linkLoyalticsAccountApi;
exports.loyaltyOffers = loyaltyOffers;
exports.postSecureAnswers = postSecureAnswers;
exports.requestSupportHelp = requestSupportHelp;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function checkLoyalticsCustomerAPI(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CHECK_LOYALTICS_CUSTOMER}?patientId=${requestParams.patientId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function linkLoyalticsAccountApi(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.LINK_LOYALTICS_ACCOUNT}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.POST });
}
function requestSupportHelp(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.LOYALTY_REQUEST_HELP_API}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.POST });
}
function loyaltyOffers(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_COUPON_DETAILS}?patientId=${requestParams.data.queryParam.patientId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getNewLoyaltics(requestParams, tokenData) {
  const query = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.NEW_LOYALTICS_CUSTOMER}${query}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getSecureQuestioner(params, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_SECURE_QUESTIONER}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getUserEligibility(requestParams, tokenData) {
  const query = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_USER_ELIGIBILITY}${query}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function postSecureAnswers(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.POST_SECURE_ANSWERS}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}